__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@mindtickle/dsr-client";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@datadog/browser-rum", "4.33.0", function() { return __webpack_require__.e(9668).then(function() { return function() { return __webpack_require__(69668); }; }); });
			register("@mui/material", "5.18.0", function() { return Promise.all([__webpack_require__.e(2992), __webpack_require__.e(433), __webpack_require__.e(7569), __webpack_require__.e(2586), __webpack_require__.e(1502), __webpack_require__.e(2324), __webpack_require__.e(6491), __webpack_require__.e(4744)]).then(function() { return function() { return __webpack_require__(32586); }; }); });
			register("@mui/private-theming", "5.17.1", function() { return Promise.all([__webpack_require__.e(1502), __webpack_require__.e(4616)]).then(function() { return function() { return __webpack_require__(24616); }; }); });
			register("@mui/styles", "5.18.0", function() { return Promise.all([__webpack_require__.e(3588), __webpack_require__.e(1502), __webpack_require__.e(3021)]).then(function() { return function() { return __webpack_require__(95754); }; }); });
			register("lodash", "4.17.21", function() { return __webpack_require__.e(147).then(function() { return function() { return __webpack_require__(70147); }; }); });
			register("react-dom", "17.0.2", function() { return Promise.all([__webpack_require__.e(6205), __webpack_require__.e(1502), __webpack_require__.e(152)]).then(function() { return function() { return __webpack_require__(26205); }; }); });
			register("react-intl", "2.9.0", function() { return Promise.all([__webpack_require__.e(8104), __webpack_require__.e(1502), __webpack_require__.e(927)]).then(function() { return function() { return __webpack_require__(48104); }; }); });
			register("react-router-dom", "6.0.0-beta.0", function() { return Promise.all([__webpack_require__.e(6284), __webpack_require__.e(1502), __webpack_require__.e(5086)]).then(function() { return function() { return __webpack_require__(13291); }; }); });
			register("react", "17.0.2", function() { return __webpack_require__.e(6040).then(function() { return function() { return __webpack_require__(16040); }; }); });
			register("styled-components", "5.3.0", function() { return Promise.all([__webpack_require__.e(8956), __webpack_require__.e(1502), __webpack_require__.e(6253)]).then(function() { return function() { return __webpack_require__(48956); }; }); });
			initExternal(92339);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};